import { gql } from '@apollo/client';

export default class AppReleaseQuery {
    static GET_UNREAD_APP_RELEASES = gql`
        query getUnreadAppReleases {
            getUnreadAppReleases {
                appReleaseId
                version
                title
                type
                content
                releaseDate
                active
                modifiedOn
            }
        }
    `;

    static GET_ALL_APP_RELEASES = gql`
        query getAllAppReleases($limit: Int, $offset: Int, $searchTerm: String) {
            getAllAppReleases(limit: $limit, offset: $offset, searchTerm: $searchTerm) {
                items {
                    appReleaseId
                    version
                    title
                    type
                    content
                    releaseDate
                    active
                    modifiedOn
                }
                total
            }
        }
    `;
}
